"use client";

import { useLocation } from "react-router-dom";
import { CrshmTopBar } from "@/components/CrshmNav";
import type { CrshmActiveTool } from "@/components/CrshmNav";

function activeFromPath(pathname: string): CrshmActiveTool {
  if (pathname === "/") return "waitlist";
  if (pathname.startsWith("/do-or-dump")) return "dod";
  if (pathname.startsWith("/blog")) return "blog";
  if (pathname.startsWith("/dashboard")) return "dashboard";
  if (pathname.startsWith("/demo")) return "waitlist";
  if (pathname.startsWith("/sign-in")) return "signin";
  if (pathname.startsWith("/admin")) return "admin";
  if (pathname.startsWith("/account/orders")) return "orders";
  if (pathname.startsWith("/account")) return "profile";
  return "waitlist";
}

export function CrshmAppHeader({
  email,
  showAdminLink,
}: {
  email?: string | null;
  showAdminLink?: boolean;
}) {
  const { pathname } = useLocation();
  const active = activeFromPath(pathname);
  return (
    <CrshmTopBar active={active} variant="light" email={email ?? null} showAdminLink={showAdminLink} />
  );
}
